import { Stack } from "@mui/material";
import { FC } from "react";
import { CommitmentUtilizationWidgetHighChart } from "@/components/pages/dashboard/components/widgets/commitment-utlization/components/CommitmentUtilizationWidgetHighChart";
import {
  GetUsersMeOrganisationsCurrentWidgetsCommitmentsUtilizationByWidgetIdApiResponse,
  WidgetCommitmentsUtilizationVisualization,
} from "@/services/cloudchipr.api";

interface InternalCommitmentUtilizationWidgetChartViewProps {
  hasAggregation: boolean;
  visualization: WidgetCommitmentsUtilizationVisualization;
  data?: GetUsersMeOrganisationsCurrentWidgetsCommitmentsUtilizationByWidgetIdApiResponse;
}

export const InternalCommitmentUtilizationWidgetChartView: FC<
  InternalCommitmentUtilizationWidgetChartViewProps
> = ({ hasAggregation, data, visualization }) => {
  const { groups } = data ?? {};

  return (
    <Stack flex={1} p={2} justifyContent={hasAggregation ? "start" : "center"}>
      <CommitmentUtilizationWidgetHighChart
        data={groups}
        visualization={visualization}
        hasAggregations={hasAggregation}
      />
    </Stack>
  );
};
